import { IAdvertiser } from "advertiser/model"
import { IEventModule } from "app/event/model"
import { IServerPagination } from "app/model"
import { CURRENCIES } from "currency/model"
import { OrderAPI } from "generated-api"

export const FORECAST_ORDER_NAME: string = "add-standing-forecast-order-do-not-use-if-you-dont-know"

export type IOrderFormSaveFn = (result: ISaveOrderResult) => any

export enum ORDER_EVENTS {
  ON_SAVE = "ON_SAVE"
}

export type IOrderDTO = Awaited<ReturnType<typeof OrderAPI.getApiOrderList>>[0]
export interface IOrder extends IOrderDTO {
  normalizedName: string
}

export type ICreateOrderRepositoryParams = Parameters<typeof OrderAPI.postApiOrder>[0]
export type IUpdateOrderRepositoryParams = Parameters<typeof OrderAPI.putApiOrder>[0]

export interface IOrderRepository {
  getAllOrders(): Promise<IOrder[]>
  getOrder(orderId: number): Promise<IOrder>
  getOrders(pagination: IServerPagination, filters: IOrderFilters): Promise<IOrder[]>
  getOrdersById(ids: number[]): Promise<IOrder[]>
  getOrdersCount(filter?: IOrderFilters): Promise<number>
  createOrder(params: ICreateOrderRepositoryParams): Promise<IOrder>
  updateOrder(params: IUpdateOrderRepositoryParams): Promise<IOrder>
}

export type ICreateOrUpdateOrderParams = IOrderFormData

export interface IOrderService {
  getAllOrders(): Promise<IOrder[]>
  createOrder(params: ICreateOrUpdateOrderParams, isDspDeal: boolean): Promise<ISaveOrderResult>
  updateOrder(orderId: number, params: ICreateOrUpdateOrderParams, isDspDeal: boolean): Promise<ISaveOrderResult>
}

export interface IOrderState {
  orders: IOrder[]
  forecastOrder: IOrder
  list: IOrderList
  isFormPopupOpened: boolean
  form: IOrderForm
}

export interface ISaveOrderResult {
  order: IOrder
  advertiser: IAdvertiser
}

export interface IOrderFilters {
  name: string
}

export interface IOrderList {
  filters: IOrderFilters
  isFilterExpanded: boolean
  filteredOrders: IOrder[]
  isRefreshing: boolean
  hasRefreshError: boolean
  pagination: IServerPagination
  rowCount: number
}

export interface IOrderRefreshListParams {
  pagination?: IServerPagination
  filters?: IOrderFilters
}

export interface IOrderFormData {
  name: string
  notes: string | null // == description (we use the column "notes" server side)
  budget: number | null
  start_date: Date | null
  end_date: Date | null
  max_impressions: number | null
  unlimitedImpressions: boolean
  budget_currency_id: CURRENCIES
  advertiserNameOrId: string | number | null
}

export type IOrderFormDataErrors = {
  [k in keyof IOrderFormData]?: string
}

export interface IOrderForm {
  isCreation: boolean
  isValid: boolean
  isLoading: boolean
  hasLoadingError: boolean
  isSaving: boolean
  initialData: IOrderFormData
  hasChanged: boolean
  data: IOrderFormData
  errors: IOrderFormDataErrors
  orderId: number
}

export interface IOrderEventOnSaveParams {
  order: IOrder
  isCreation: boolean
}

export interface IOrderEventModule extends IEventModule {
  on: {
    onSave(listenerId: string, fn: (params: IOrderEventOnSaveParams) => void): void
  }
}
